/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint linebreak-style: ["error", "windows"] */
import React, { useState } from 'react';
import {
    Button, Select, Modal, TextArea, DatePicker,
} from '@scuf/common';
import IModalProps from '@scuf/common/dist/components/Modal/IModalProps';

import withAuthContext from '../../helpers/Auth/withAuth';
import { IAuthContextProps } from '../../models/IAuthModel';
import {
    testTypeDetails,
} from '../../constanFile.js';

interface Props extends IModalProps, IAuthContextProps {}
const AddScheduleTest = ({
    open, onClose, ...others
}: Props) => {
    const [isTestName, setTestName] = useState('');
    const [isDescription, setDescription] = useState('');
    const [isTestDate, setTestDate] = useState('');

    const isSubmitEnabled = () => isTestName?.length && isDescription?.length && isTestDate?.length;
    return (
        <Modal
            data-testid="editTestTypeModal"
            className="modal500"
            size="small"
            closeIcon
            onClose={onClose}
            open={open}
            {...others}
        >
            <div>
                <h2>Add Schedule Test</h2>
                <form>
                    <div className="m10">
                        <span className="m10">
                            <Select
                                search
                                label="Test"
                                className="wselect23"
                                indicator="required"
                                placeholder="Select"
                                options={testTypeDetails}
                                onChange={setTestName}
                                value={isTestName}
                            />
                        </span>
                    </div>
                    <div className="m10">
                        <span className="m10">
                            <TextArea
                                label="Test Description"
                                indicator="required"
                                rows={1}
                                placeholder="Description..."
                                onChange={setDescription}
                                value={isDescription}
                            />
                        </span>
                    </div>
                    <div className="m10">

                        <span className="m10">
                            <DatePicker
                                label="Test Date"
                                className="wselect23"
                                placeholder="Select Date"
                                onTextChange={setTestDate}
                                value={isTestDate}
                            />
                        </span>
                    </div>
                    <div className="modal-bottom-button-container">
                        <span className="m10Horizontal">
                            <Button type="secondary" actionType="submit">Cancel</Button>
                        </span>
                        <span>
                            <Button type="primary" disabled={!isSubmitEnabled()} actionType="submit">Confirm</Button>
                        </span>
                    </div>
                </form>
            </div>
        </Modal>
    );
};
export default withAuthContext(AddScheduleTest);
